let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9w7H2")).then(() => parcelRequire('ZdSUn'));